export default __webpack_public_path__ + "static/media/scss.c3a1c701.png";